import configure from "configure"
import React from "react"
import { getInitials } from "utils/common-helpers"

export const SixMonsLeaveColumn = () => {
  const authId = localStorage?.getItem("auth_id");
  const isAuthorized = [1, 32, 4, 46].includes(Number(authId));

  const columns = [
    {
      Header: "Month",
      accessor: "month",
      isInfoIcon: false,
      isShortIcon: true,
      className: "text-center lemp-id",
    },
    {
      Header: "Leaves",
      accessor: "leaves",
      isInfoIcon: false,
      isShortIcon: true,
      className: "text-center lemp-id",
    },
    ...(isAuthorized
      ? [
        {
          Header: "Working Days",
          accessor: "workingDays",
          isInfoIcon: false,
          isShortIcon: true,
          className: "text-center lemp-id",
        },
        {
          Header: "Percentage",
          accessor: "ratio",
          isInfoIcon: false,
          isShortIcon: true,
          className: "text-center lemp-id",
          Cell: cellProps => <div>{cellProps.value ?? 0}{' '}%</div>,
        },
      ]
      : []),
  ];

  return columns;
};

export const Absentees = () => [
  {
    Header: "Sr. No",
    isInfoIcon: false,
    isShortIcon: true,
    accessor: "serial_no",
    className: "db_swipe_id text-center",
    width: "10%",
    Cell: cellProps => <div>{cellProps.row.index + 1}</div>,
  },
  {
    Header: "Staff Id",
    isInfoIcon: false,
    isShortIcon: true,
    className: "db_swipe_id text-center",
    width: "20%",
    Cell: cellProps => (
      <div
        className="d-flex align-items-center justify-content-center"
        style={{ gap: "8px" }}
      >
        {cellProps.row.original.avatar ? (
          <img
            src={`${configure.imgUrl}/${cellProps.row.original.avatar}`}
            alt={cellProps.row.original.alias_name}
            style={{ width: "30px", height: "30px", borderRadius: "50%" }}
          />
        ) : (
          <div className="defualt-img" title={cellProps?.row?.original?.alias_name}>
            {getInitials(cellProps?.row?.original?.alias_name || "Z")}
          </div>
        )}
        <span>{cellProps.row.original.employee_code}</span>
      </div>
    ),
  },
  {
    Header: "Name",
    accessor: "alias_name",
    isInfoIcon: false,
    isShortIcon: true,
    className: "text-center",
    width: "60%",
  },
  {
    Header: "Status",
    accessor: row => row.leave_status ?? "-",
    isInfoIcon: false,
    isShortIcon: true,
    className: "text-center",
    width: "30%",
  }
]
